import React, { Component } from 'react'
import PropTypes from 'prop-types'

var tr = require('ts-translate-js').default.boundTR;
var up = require('react-addons-update');

export class EditShippingAddressPanel extends Component {

    isEmpty(val) {
        return (val == null || val == "")
    }

    handleOnDescriptionChange(e) {
        this.props.onModifyShippingAddress(up(this.props.shippingAddress, { "Description": { $set: e.target.value } }))
    }

    handleOnNameChange(e) {
        this.props.onModifyShippingAddress(up(this.props.shippingAddress, { "Name": { $set: e.target.value } }))
    }

    handleOnFirstPartAddress(e) {
        this.props.onModifyShippingAddress(up(this.props.shippingAddress, { "Address1": { $set: e.target.value } }))
    }

    handleOnSecondPartAddress(e) {
        this.props.onModifyShippingAddress(up(this.props.shippingAddress, { "Address2": { $set: e.target.value } }))
    }

    handleOnCityChange(e) {
        this.props.onModifyShippingAddress(up(this.props.shippingAddress, { "City": { $set: e.target.value } }))
    }

    handleOnProvinceChange(e) {
        this.props.onModifyShippingAddress(up(this.props.shippingAddress, { "Province": { $set: e.target.value } }))
    }

    handleOnPostalCodeChange(e) {
        this.props.onModifyShippingAddress(up(this.props.shippingAddress, { "PostalCode": { $set: e.target.value } }))
    }

    handleOnCountryChange(e) {
        this.props.onModifyShippingAddress(up(this.props.shippingAddress, { "Country": { $set: e.target.value } }))
    }

    handleOnCancel() {
        this.props.onCancelEditShippingAddress()
    }

    handleOnConfirm(e) {
        e.stopPropagation();
        e.preventDefault();
        this.props.onConfirmEditShippingAddress(this.props.shippingAddress);
    }


    shippingAddressEditError() {
        var message = ""

        if (this.props.shippingAddressErrorResult.MissingFields)
            message = tr("shippingaddresspanel.requiredfieldmissing")
        else if (this.props.shippingAddressErrorResult.InvalidPostalCodeFormat)
            message = tr("shippingaddresspanel.invalidpostalcodeformat")
        else
            message = tr("shippingaddresspanel.errorhasoccured")

        return (<div className="form-group">
            <div className="alert alert-danger text-center" role="alert">{message}</div>
        </div>)
    }

    render() {

        if (this.props.shippingAddress === null) {
            return (<div>{tr("shippingaddresspanel.loading")}</div>)
        }

        var errorMessage = this.props.showEditShippingError && this.props.shippingAddressErrorResult != null
            ? this.shippingAddressEditError()
            : null

        return (
            <div className="container-fluid">asdfsfd fsdfdsfdsfdsfd
                <form onSubmit={(e) => this.handleOnConfirm(e)}>
                    <h3 className="text-center">{tr("shippingaddresspanel.editShippingAddress")}</h3>
                    <div className="form-horizontal">
                        <div className="form-group">
                            <label htmlFor="inputDescription" className="control-label">{tr("profileinfo.description")}</label>
                            <input type="text" id="inputDescription" className="form-control" value={this.props.shippingAddress.Description} onChange={(e) => this.handleOnDescriptionChange(e)}></input>
                        </div>

                        <div className="form-group">
                            <label htmlFor="inputName" className="control-label">{tr("profileinfo.name")}</label>
                            <input type="text" id="inputName" className="form-control" value={this.props.shippingAddress.Name} onChange={(e) => this.handleOnNameChange(e)}></input>
                        </div>

                        <div className="form-group">
                            <label htmlFor="inputAddress1" className="control-label">{tr("profileinfo.address")}</label>
                            <input type="text" id="inputAddress1" className="form-control" value={this.props.shippingAddress.Address1} onChange={(e) => this.handleOnFirstPartAddress(e)}></input>
                        </div>

                        <div className="form-group">
                            <label htmlFor="inputAddress2" className="control-label">{tr("profileinfo.address2")}</label><span> <em>{tr("profileedition.optional")}</em></span>
                            <input type="text" id="inputAddress2" className="form-control" value={this.props.shippingAddress.Address2} onChange={(e) => this.handleOnSecondPartAddress(e)}></input>
                        </div>

                        <div className="form-group">
                            <label htmlFor="inputCity" className="control-label">{tr("profileinfo.city")}</label>
                            <input type="text" id="inputCity" className="form-control" value={this.props.shippingAddress.City} onChange={(e) => this.handleOnCityChange(e)}></input>
                        </div>

                        <div className="form-group">
                            <label htmlFor="inputProvince" className="control-label">{tr("profileinfo.province")}</label>
                            <input type="text" id="inputProvince" className="form-control" value={this.props.shippingAddress.Province} onChange={(e) => this.handleOnProvinceChange(e)}></input>
                        </div>

                        <div className="form-group">
                            <label htmlFor="inputPostalCode" className="control-label">{tr("profileinfo.postalcode")}</label>
                            <input type="text" id="inputPostalCode" className="form-control" value={this.props.shippingAddress.PostalCode} onChange={(e) => this.handleOnPostalCodeChange(e)}></input>
                        </div>

                        <div className="form-group">
                            <label htmlFor="inputCountry" className="control-label">{tr("profileinfo.country")}</label>
                            <input type="text" id="inputCountry" className="form-control" value={this.props.shippingAddress.Country} onChange={(e) => this.handleOnCountryChange(e)}></input>
                        </div>
                        {errorMessage}
                        <div className="form-group">
                            <div className="btn-toolbar pull-right">
                                <button className="btn btn-default" type="button" onClick={() => this.handleOnCancel()}>{tr("shippingaddresspanel.cancel")}</button>
                                <button className="btn btn-primary" type="submit">{tr("shippingaddresspanel.confirm")}</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        ) 
    }
}

EditShippingAddressPanel.propTypes = {
    shippingAddress: PropTypes.shape,
    onModifyShippingAddress: PropTypes.func,
    onConfirmEditShippingAddress: PropTypes.func,
    onCancelEditShippingAddress: PropTypes.func,
    onFailedEditShippingOK: PropTypes.func,
    shippingAddressErrorResult: PropTypes.shape,
    showEditShippingError: PropTypes.bool
}

export default EditShippingAddressPanel;
